<router-outlet></router-outlet>

<ng-template #subsubmenuContent>
  <div class="subSideMenu">
    <ul class="list-none px-3">

      @if (store.serviceType()?.type === ServiceTypeEnum.SOCIAL) {
        <li class="subSideMenu-header">
          <div>{{ 'serviceType.labels.subMenuSocialService' | translate }}</div>
        </li>
        <ng-container
                    *ngTemplateOutlet="itemGroup;
                 context: { itemGroup: socialSettingItems, active: activeSegment() }"
        ></ng-container>
      }

      <li class="subSideMenu-header">
        <div>{{ 'serviceType.labels.subMenuGeneral' | translate }}</div>
      </li>
      <ng-container
                  *ngTemplateOutlet="itemGroup;
               context: { itemGroup: generalSettingItems, active: activeSegment() }"
      ></ng-container>

    </ul>
  </div>
</ng-template>

<ng-template #itemGroup let-itemGroup="itemGroup" let-active="active">
  @for (item of itemGroup; track item) {
    <li class="subSideMenu-item">
      <div
        pRipple
        [ngClass]="['subSideMenu-link', item === active ? 'subSideMenu-link_active' : '']"
        (click)="itemOnClick(item)"
        >
        {{ 'serviceType.' + item + '.labelMulti' | translate }}
      </div>
    </li>
  }
</ng-template>
